{
    "v": "5.9.0",
    "fr": 25,
    "ip": 0,
    "op": 62,
    "w": 500,
    "h": 500,
    "nm": "32 download file",
    "ddd": 0,
    "assets": [
        {
            "id": "comp_0",
            "nm": "Arrow and line",
            "fr": 25,
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 4,
                    "nm": "Line short",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [249.81, 210.918, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [56.269, 8, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.833, "y": 0.833 },
                                                "o": { "x": 0.167, "y": 0.167 },
                                                "t": 9,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [8, 8],
                                                            [9.538, 7.918]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.833, "y": 0.833 },
                                                "o": { "x": 0.167, "y": 0.167 },
                                                "t": 25,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [21.875, 8.014],
                                                            [79.413, 8.059]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.833, "y": 0.833 },
                                                "o": { "x": 0.167, "y": 0.167 },
                                                "t": 28,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [21.875, 8.014],
                                                            [79.413, 8.059]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 44,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [109.5, 8.127],
                                                            [108.038, 7.918]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Trazado 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0.20000001496, 0.800000059838, 0.800000059838, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": { "a": 0, "k": 16, "ix": 5 },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Trazo 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transformar"
                                }
                            ],
                            "nm": "Grupo 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 12,
                    "op": 44,
                    "st": -5,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 4,
                    "nm": "Line",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [249.81, 210.918, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [56.269, 8, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [8, 8],
                                                [104.538, 8]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Trazado 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": { "a": 0, "k": 16, "ix": 5 },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Trazo 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transformar"
                                }
                            ],
                            "nm": "Grupo 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 63,
                    "st": -3,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 3,
                    "ty": 4,
                    "nm": "Arrow ",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": { "x": 0.2, "y": 1 },
                                    "o": { "x": 0.6, "y": 0 },
                                    "t": 10,
                                    "s": [251.945, 265.321, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.2, "y": 1 },
                                    "o": { "x": 0.6, "y": 0 },
                                    "t": 24,
                                    "s": [251.945, 244.321, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.2, "y": 1 },
                                    "o": { "x": 0.6, "y": 0 },
                                    "t": 39,
                                    "s": [251.945, 281.321, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 2.667, 0]
                                },
                                { "t": 56, "s": [251.945, 265.321, 0] }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": { "a": 0, "k": [10.135, 14.135, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-24.134, -24.135],
                                                [24.134, 24.135]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Trazado 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0.2, 0.8, 0.8, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": { "a": 0, "k": 16, "ix": 5 },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Trazo 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [32.134, 32.135], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transformar"
                                }
                            ],
                            "nm": "Grupo 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": { "a": 0, "k": 0, "ix": 1 },
                            "e": { "a": 0, "k": 100, "ix": 2 },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Recortar trazados 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-23.135, 24.135],
                                                [25.135, -24.135]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Trazado 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0.2, 0.8, 0.8, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": { "a": 0, "k": 16, "ix": 5 },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Trazo 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [-17.102, 32.135], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transformar"
                                }
                            ],
                            "nm": "Grupo 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [8, 116.605],
                                                [8, 8]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Trazado 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0.2, 0.8, 0.8, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": { "a": 0, "k": 16, "ix": 5 },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Trazo 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transformar"
                                }
                            ],
                            "nm": "Grupo 3",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 63,
                    "st": -3,
                    "bm": 0
                }
            ]
        }
    ],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 5,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Deslizador",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 16, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Base Color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0, 0, 0, 1], "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0.20000000298, 0.800000011921, 0.800000011921, 1], "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 62,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 0,
            "nm": "Arrow and line",
            "parent": 4,
            "refId": "comp_0",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 180, "ix": 10 },
                "p": { "a": 0, "k": [186.552, 292.473, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [250, 250, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "w": 500,
            "h": 500,
            "ip": 0,
            "op": 62,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Fold",
            "parent": 4,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [86.005, 86.755, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [82.256, 82.256, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 13.335],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [13.335, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-32.255, 42.432],
                                        [32.11, 42.432],
                                        [56.256, 18.286],
                                        [56.209, -46.579]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [82.256, 82.255], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 63,
            "st": -3,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Paper",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 7,
                            "s": [18.142, 26.517, 0],
                            "to": [0, -5, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 24,
                            "s": [18.142, -3.483, 0],
                            "to": [0, 0, 0],
                            "ti": [0, -5, 0]
                        },
                        { "t": 44, "s": [18.142, 26.517, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [154.694, 196.949, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, -13.335],
                                        [0, 0],
                                        [13.334, 0],
                                        [0, 0],
                                        [0, 13.334]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [13.334, 0],
                                        [0, 0],
                                        [0, 13.334],
                                        [0, 0],
                                        [-13.335, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-100.694, -84.495],
                                        [-28.256, -156.933],
                                        [141.048, -155.944],
                                        [165.194, -131.798],
                                        [165.086, 183.809],
                                        [140.94, 207.955],
                                        [-76.656, 206.966],
                                        [-100.802, 182.82]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 16,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Deslizador');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [154.694, 196.949], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 63,
            "st": -3,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 62,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
